var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlotDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5H4.16667H17.5",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 5.00033V16.667C15.8334 17.109 15.6578 17.5329 15.3453 17.8455C15.0327 18.1581 14.6088 18.3337 14.1667 18.3337H5.83341C5.39139 18.3337 4.96746 18.1581 4.6549 17.8455C4.34234 17.5329 4.16675 17.109 4.16675 16.667V5.00033M6.66675 5.00033V3.33366C6.66675 2.89163 6.84234 2.46771 7.1549 2.15515C7.46746 1.84259 7.89139 1.66699 8.33341 1.66699H11.6667C12.1088 1.66699 12.5327 1.84259 12.8453 2.15515C13.1578 2.46771 13.3334 2.89163 13.3334 3.33366V5.00033",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 9.16699V14.167",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 9.16699V14.167",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotDelete);
export default __webpack_public_path__ + "static/media/slot-delete.4ef4f66a465150f9c4bbe10d4ce4851c.svg";
export { ForwardRef as ReactComponent };